import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import HeroSection from "./Components/HeroSection";
import Features from './Components/Features';
import Events from './Components/Events';
import Team from './Components/team';
/*<div>
      <HeroSection/>
      <Features/>
      <Events/>
  </div>*/

function App() {
  return (
    <div>
      <HeroSection/>
      <Events/>
      <Features/>
      <Team/>
  </div>
    
  );
}

export default App;
